import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import SignUp from "./SignUp";
import { AuthProvider } from "./Auth";
import PrivateRoute from "./PrivateRoute";
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import FichiersPdf from "./pages/Fichiers-catalogues-clients";
import FichiersJson from "./pages/Fichier-produits-clients";
import FichiersPdfSiteInternet from "./pages/Fichiers-pdf-site-internet";
import ListProduits from "./pages/List-produits-clients";
import ListChainesPl from "./components/listes-produits/chaines-pl";
import ListChainesVl from "./components/listes-produits/chaines-vl";
import ListChainesForestieres from "./components/listes-produits/chaines-forestieres";
import ListChainesDeneigement from "./components/listes-produits/chaines-deneigement";
import ListPdfClients from "./pages/List-catalogues-clients";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <PrivateRoute exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />
          <PrivateRouteAdmin exact path="/signup" component={SignUp} />
          <PrivateRouteAdmin
            exact
            path="/fichiers-catalogues-clients"
            component={FichiersPdf}
          />
          <PrivateRouteAdmin
            exact
            path="/fichiers-produits-clients"
            component={FichiersJson}
          />
          <PrivateRoute exact path="/chaines-pl" component={ListChainesPl} />
          <PrivateRoute exact path="/chaines-vl" component={ListChainesVl} />
          <PrivateRoute
            exact
            path="/chaines-forestieres"
            component={ListChainesForestieres}
          />
          <PrivateRoute
            exact
            path="/chaines-deneigement"
            component={ListChainesDeneigement}
          />
          <PrivateRoute exact path="/liste-catalogues" component={ListPdfClients} />
          <PrivateRouteAdmin
            exact
            path="/fichiers-pdf-site-internet"
            component={FichiersPdfSiteInternet}
          />
          <PrivateRoute exact path="/liste-produits" component={ListProduits} />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
